import React from 'react';
import { X, Check } from 'lucide-react';
import { SectionHeader } from '../ui/Shared';
export function BeforeAfterSection() {
  const isFor = ['Sufren reflujo o acidez constante', 'Sienten ardor en el pecho o garganta', 'No pueden dormir bien por el ácido', 'Toman omeprazol o medicamentos', 'Tienen gastritis o hernia hiatal', 'Sienten que todo les da ardor'];
  const notFor = ['Personas que buscan una pastilla mágica sin hacer ningún ajuste.', 'Quienes prefieren depender de medicamentos de por vida.', 'Casos de emergencia médica que requieren cirugía inmediata.'];
  return <section id="para-quien" className="py-24" data-id="element-63">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-64">
        <SectionHeader tag="¿Es para ti?" title={<>¿Para quién es esto?</>} data-id="element-65" />

        <div className="scale-in grid grid-cols-1 md:grid-cols-2 gap-0 rounded-2xl overflow-hidden mt-12 border border-white/10" data-id="element-66">
          {/* Is For Column */}
          <div className="bg-success/5 p-8 md:p-10 border-b md:border-b-0 md:border-r border-white/5" data-id="element-67">
            <div className="flex items-center gap-3 mb-7" data-id="element-68">
              <div className="w-10 h-10 rounded-full bg-success/15 flex items-center justify-center" data-id="element-69">
                <Check className="w-5 h-5 text-success" data-id="element-70" />
              </div>
              <h3 className="text-lg font-bold text-[#68D391]" data-id="element-71">
                SÍ es para ti si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-72">
              {isFor.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-[15px] text-text-light" data-id="element-73">
                  <Check className="w-4 h-4 text-success mt-1 shrink-0" data-id="element-74" />
                  <span className="leading-relaxed" data-id="element-75">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For Column */}
          <div className="bg-danger/5 p-8 md:p-10" data-id="element-76">
            <div className="flex items-center gap-3 mb-7" data-id="element-77">
              <div className="w-10 h-10 rounded-full bg-danger/15 flex items-center justify-center" data-id="element-78">
                <X className="w-5 h-5 text-danger" data-id="element-79" />
              </div>
              <h3 className="text-lg font-bold text-danger-outlined" data-id="element-80">
                NO es para ti si...
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-81">
              {notFor.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-[15px] text-text-muted" data-id="element-82">
                  <X className="w-4 h-4 text-danger mt-1 shrink-0" data-id="element-83" />
                  <span className="leading-relaxed" data-id="element-84">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}